const H6 = ({ children, className, onClick }) => {
  return (
    <h6
      className={`text-sm font-normal leading-5 dark:text-dark_primary_label  text-light_primary_label ${className}`}
      onClick={onClick}
    >
      {children}
    </h6>
  );
};

export default H6;
